module.exports = __webpack_public_path__ + "static/img/xiangshangjiantouIcon.acedc9d1.svg";